import { Sparkles } from "lucide-react";
import React, { useEffect, useState, useRef } from "react";
import "./LandingPage.css";
import logs from "../../Assets/Image/logos.png";
import contact from "../../Assets/Image/service-thumb1.png";
import { message } from "antd";
import paterol from "../../Assets/Image/paterolling.png"
import regularvisit from "../../Assets/Image/regularvisitor.png"
import visitor from "../../Assets/Image/visitor.png"
import { 
  Wrench, TrendingUp, Building2, Users, ShieldCheck, BarChart3, 
  UserCheck, Home, Settings, IndianRupee, FileCheck, Droplet,Zap, Mail 
 } from 'lucide-react';
import Services from "./Services";
import AudioEnableModal from "../../VoiceOutput/AudioEnableModal";
import { voiceService } from "../../VoiceOutput/VoiceService";
import { FeaturesUniverse } from "./FeaturesUniverse";
import AnikaAiAnimation from "./AnikaAiAnimation";
import { useNavigate } from "react-router-dom";
import AnikaAi from "./AnikaAi";
 const LandingPage = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeIntegration, setActiveIntegration] = useState(0);
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [emailfooter, setEmailFooter] = useState("");
  const [activeRoom, setActiveRoom] = useState(0);
  // const [showBrowserWarning, setShowBrowserWarning] = useState(false);
  const [showAudioModal, setShowAudioModal] = useState(true);
  const [pageReady, setPageReady] = useState(false);
  const [showSpeakerWarning, setShowSpeakerWarning] = useState(false);
  // const [isChrome, setIsChrome] = useState(true);                
  const [visibleCards, setVisibleCards] = useState({});
  const [isIntegrationsVisible, setIsIntegrationsVisible] = useState(false);
  const integrationsRef = useRef(null);
  const canvasRef = useRef(null);
  const homeRef = useRef(null);
  const serviceRef = useRef(null);
  const aboutRef = useRef(null);
  const contactRef = useRef(null);
  // const signallerRef= useRef(null)
  const sectionRef = useRef(null);
  const navigate= useNavigate();
  // Add this state at the top with other useState declarations (around line 21)
const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
// ========================= for voice =================
// EXISTING (keep):
const [anikaAutoStart,       setAnikaAutoStart]       = useState(false);
const [anikaExternalTrigger, setAnikaExternalTrigger] = useState(null);
const [anikaCallActive,      setAnikaCallActive]      = useState(false);
const [serviceSectionSpoken, setServiceSectionSpoken] = useState(false);
const [adminSectionSpoken,   setAdminSectionSpoken]   = useState(false);
// ADD - tracks which section the user is currently viewing
const [currentViewSection, setCurrentViewSection] = useState('home');
// ADD THIS NEW STATE:
const [serviceActiveIntegration, setServiceActiveIntegration] = useState(0);


// ── Detect which section user is currently viewing ─────────────
useEffect(() => {
  const observers = [];

  const sections = [
    { ref: homeRef,          name: 'home'    },
    { ref: serviceRef,       name: 'service' },
    { ref: integrationsRef,  name: 'admin'   },
  ];

  sections.forEach(({ ref, name }) => {
    if (!ref.current) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) setCurrentViewSection(name);
        });
      },
      { threshold: 0.4 }
    );
    obs.observe(ref.current);
    observers.push(obs);
  });

  return () => observers.forEach(o => o.disconnect());
}, []);
// Add this function to toggle mobile menu
const toggleMobileMenu = () => {
  setIsMobileMenuOpen(!isMobileMenuOpen);
};
  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });
 const rooms = [
  {
      id: 'regularVisitor',
      name: 'Visitor Management',
      title: 'Visitor Management',
      description: 'Advanced digital visitor management system that streamlines guest registration, automates check-in/check-out processes, and maintains comprehensive visitor logs. Real-time notifications to hosts, pre-registration capabilities, and seamless integration with access control systems ensure efficient visitor tracking while maintaining the highest security standards.',
      image: regularvisit,
      color: '#8b5cf6'
    },
    {
      id: 'patrolling',
      name: 'Patrolling',
      title: 'Patrolling',
      description: 'Regular security patrols ensuring safety and surveillance across all designated areas. Comprehensive monitoring with systematic route coverage for maximum protection.',
      image: paterol,
      color: '#6366f1'
    },
    // {
    //   id: 'visitor',
    //   name: 'Visitor',
    //   title: 'Visitor',
    //   description: 'Comprehensive visitor screening and registration system. Secure check-in process with real-time notifications and detailed logging for enhanced premises security.',
    //   image: visitor,
    //   color: '#ec4899'
    // },
    {
      id: 'emergency',
      name: 'Emergency Response',
      title: 'Emergency Response',
      description: 'Rapid response protocols for critical situations. Immediate alert systems with trained personnel ready to handle emergencies and coordinate with local authorities efficiently.',
      image: 'https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=800&q=80',
      color: '#ef4444'
    },
    {
      id: 'monitoring',
      name: '24/7 Monitoring',
      title: '24/7 Monitoring',
      description: 'Round-the-clock surveillance with advanced monitoring systems. Live feed analysis and intelligent detection ensuring continuous security coverage day and night.',
      image: 'https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=800&q=80',
      color: '#10b981'
    }
  ];
 useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;

      const section = sectionRef.current;
      const rect = section.getBoundingClientRect();
      const scrollProgress = Math.max(0, -rect.top);
      const sectionHeight = section.offsetHeight - window.innerHeight;
      
      const progress = Math.min(scrollProgress / sectionHeight, 1);
      const newIndex = Math.min(
        Math.floor(progress * rooms.length),
        rooms.length - 1
      );
      
      setActiveRoom(newIndex);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [rooms.length]);

  const [errors, setErrors] = useState({
    fullName: "",
    phone: "",
    email: "",
    subject: "",
  });

  const [touched, setTouched] = useState({
    fullName: false,
    phone: false,
    email: false,
    subject: false,
  });
  // Scroll to section function

  useEffect(() => {
  // Check if audio is supported and show warning
  if (voiceService.checkAudioSupport()) {
    setShowSpeakerWarning(true);
  }
  }, []);

  useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (entry.target.id === 'integrations-section') {
            setIsIntegrationsVisible(true);
          } else {
            setVisibleCards(prev => ({ ...prev, [entry.target.id]: true }));
          }
        }
      });
    },
    { threshold: 0.2 }
  );

  document.querySelectorAll('.feature-card').forEach((el) => {
    observer.observe(el);
  });

  // Observe integrations section
  const integrationsEl = document.getElementById('integrations-section');
  if (integrationsEl) {
    observer.observe(integrationsEl);
  }

  return () => observer.disconnect();
  }, []);
// Add this function inside the component, before the return statement
// const detectBrowser = () => {
//   const userAgent = navigator.userAgent.toLowerCase();
//   const isChromeBrowser = /chrome/.test(userAgent) && !/edg/.test(userAgent) && !/opr/.test(userAgent);
//   return isChromeBrowser;
// };
const scrollToSection = (ref) => {
  ref.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
};
  // =================================  form handle for contact us ====================
  const validateName = (name) => {
    const trimmedName = name.trim();
    if (!trimmedName) {
      return "Name is required";
    }
    if (/\d/.test(trimmedName)) {
      return "Name cannot contain numbers";
    }
    if (trimmedName.length < 2) {
      return "Name must be at least 2 characters";
    }
    return "";
  };

  const validatePhone = (phone) => {
    const digitsOnly = phone.replace(/\D/g, "");
    if (!digitsOnly) {
      return "Phone number is required";
    }
    if (digitsOnly.length !== 10) {
      return "Phone number must be exactly 10 digits";
    }
    return "";
  };

  const validateEmail = (email) => {
    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      return "Email is required";
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(trimmedEmail)) {
      return "Please enter a valid email address";
    }
    if (
      !trimmedEmail.endsWith(".com") &&
      !trimmedEmail.endsWith(".net") &&
      !trimmedEmail.endsWith(".org")
    ) {
      return "Email must end with .com, .net, or .org";
    }
    return "";
  };

  const validateSubject = (subject) => {
    const trimmedSubject = subject.trim();
    if (!trimmedSubject) {
      return "Subject is required";
    }
    return "";
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    let newValue = value;

    // For phone, only allow digits and limit to 10
    if (name === "phone") {
      const digitsOnly = value.replace(/\D/g, "");
      newValue = digitsOnly.slice(0, 10);
    }

    setFormData({
      ...formData,
      [name]: newValue,
    });

    // Validate on change if field has been touched
    if (touched[name]) {
      let error = "";
      switch (name) {
        case "fullName":
          error = validateName(newValue);
          break;
        case "phone":
          error = validatePhone(newValue);
          break;
        case "email":
          error = validateEmail(newValue);
          break;
        case "subject":
          error = validateSubject(newValue);
          break;

        default:
          break;
      }
      setErrors({
        ...errors,
        [name]: error,
      });
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    setTouched({
      ...touched,
      [name]: true,
    });

    let error = "";
    switch (name) {
      case "fullName":
        error = validateName(value);
        break;
      case "phone":
        error = validatePhone(value);
        break;
      case "email":
        error = validateEmail(value);
        break;
      case "subject":
        error = validateSubject(value);
        break;
      default:
        break;
    }

    setErrors({
      ...errors,
      [name]: error,
    });
  };

  const handleSubmitform = () => {
    // Mark all fields as touched
    const allTouched = {
      fullName: true,
      phone: true,
      email: true,
      subject: true,
      message: true,
    };
    setTouched(allTouched);

    // Validate all fields
    const newErrors = {
      fullName: validateName(formData.fullName),
      phone: validatePhone(formData.phone),
      email: validateEmail(formData.email),
      subject: validateSubject(formData.subject),
      // message: validateMessage(formData.message),
    };

    setErrors(newErrors);

    // Check if there are any errors
    const hasErrors = Object.values(newErrors).some((error) => error !== "");

    if (!hasErrors) {
      // Trim all values before submitting
      const trimmedData = {
        fullName: formData.fullName.trim(),
        phone: formData.phone.trim(),
        email: formData.email.trim(),
        subject: formData.subject.trim(),
        message: formData.message.trim(),
      };

      message.success("Form submitted successfully!");
      console.log("Form Data:", trimmedData);

      // Reset form
      setFormData({
        fullName: "",
        phone: "",
        email: "",
        subject: "",
        message: "",
      });
      setErrors({
        fullName: "",
        phone: "",
        email: "",
        subject: "",
        message: "",
      });
      setTouched({
        fullName: false,
        phone: false,
        email: false,
        subject: false,
        message: false,
      });
    }
  };

  const handleSubmitFooter = (e) => {
    e.preventDefault();
    console.log("Email submitted:", email);
    // Add your newsletter submission logic here
  };
  const handleSubmit = () => {
    if (email) {
      setIsSubmitted(true);
      setTimeout(() => {
        setIsSubmitted(false);
        setEmail("");
      }, 3000);
    }
  };
const integrations = [
    {
      id: 1,
      icon: Wrench,
      name: "Maintenance",
      description: "Streamline maintenance requests and track repairs efficiently with automated scheduling and real-time updates.",
      circle: "inner",
      color: "#10b981"
    },
    {
      id: 2,
      icon: TrendingUp,
      name: "Budget Planning",
      description: "Plan and manage your society budget with intelligent forecasting and expense tracking tools.",
      circle: "inner",
      color: "#3b82f6"
    },
    {
      id: 3,
      icon: Building2,
      name: "Asset Management",
      description: "Keep track of all society assets, their condition, and maintenance schedules in one centralized system.",
      circle: "inner",
      color: "#8b5cf6"
    },
    {
      id: 4,
      icon: Users,
      name: "Society Management",
      description: "Complete society administration solution with member management, communication, and governance tools.",
      circle: "inner",
      color: "#ec4899"
    },
    {
      id: 5,
      icon: ShieldCheck,
      name: "Patrolling",
      description: "Monitor security patrols with GPS tracking, incident reporting, and scheduled checkpoints.",
      circle: "inner",
      color: "#f59e0b"
    },
    {
      id: 6,
      icon: BarChart3,
      name: "Community Polling",
      description: "Engage residents with polls and surveys to make democratic decisions and gather feedback.",
      circle: "inner",
      color: "#06b6d4"
    },
    {
      id: 7,
      icon: UserCheck,
      name: "Visitor Management",
      description: "Manage and track visitor entries with digital registration, pre-approval, and security notifications.",
      circle: "outer",
      color: "#14b8a6"
    },
    {
      id: 8,
      icon: Home,
      name: "Home Automation",
      description: "Control smart home devices and automate your living space for comfort and energy efficiency.",
      circle: "outer",
      color: "#f97316"
    },
    
  ];
  const testimonials = [
    {
      id: 1,
      quote:
        "Streamline maintenance requests and track repairs efficiently with automated scheduling and real-time updates.",
      name: "Maintenance",
      role: "Maintenance Manager",
    },
    {
      id: 2,
      quote:
        "Plan and manage your society budget with intelligent forecasting and expense tracking tools.",
      name: "Budget Planning",
      role: "Treasurer",
    },
    {
      id: 3,
      quote:
        "Complete society administration solution with member management, communication, and governance tools.",
      name: "Society Management",
      role: "Society Secretary",
    },
    {
      id: 4,
      quote:
        "Engage residents with polls and surveys to make democratic decisions and gather feedback.",
      name: "Community Polling",
      role: "Resident Welfare Committee Member",
    },
  ];

const texts = [
  "Hi, I’m ANIKA — your AI-powered assistant for smart apartment and society management. I help manage services, admin features, signaller functions, and daily operations to make community living simple, secure, and connected.",
  "Please scroll down to explore our services and features."
];

  // Particle system
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const particles = [];
    const particleCount = 20;

    class Particle {
      constructor() {
        this.x = Math.random() * canvas.width;
        this.y = canvas.height + Math.random() * 100;
        this.size = Math.random() * 3 + 1;
        this.speedY = Math.random() * 1.5 + 0.5;
        this.speedX = Math.random() * 0.5 - 0.25;
        this.opacity = Math.random() * 0.5 + 0.3;
      }

      update() {
        this.y -= this.speedY;
        this.x += this.speedX;

        if (this.y < -10) {
          this.y = canvas.height + 10;
          this.x = Math.random() * canvas.width;
        }

        if (this.x < 0 || this.x > canvas.width) {
          this.x = Math.random() * canvas.width;
        }
      }

      draw() {
        ctx.fillStyle = `rgb(236,148,253, ${this.opacity})`;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    for (let i = 0; i < particleCount; i++) {
      particles.push(new Particle());
    }

    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.forEach((particle) => {
        particle.update();
        particle.draw();
      });

      requestAnimationFrame(animate);
    }

    animate();

    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Rotation animation
 useEffect(() => {
    const interval = setInterval(() => {
      setActiveIntegration((prev) => (prev + 1) % integrations.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

const handleStartExperience = () => {
  setShowAudioModal(false);
  setPageReady(true);
  // Trigger AnikaAi to auto-start and speak intro
  setAnikaAutoStart(true);
};

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

useEffect(() => {
  const handleScroll = () => {
    const scrolled = window.pageYOffset;
    const bg = document.querySelector(".society-main-home-gap");
    
    // Check if element exists before accessing style
    if (bg) {
      bg.style.backgroundPositionY = `${scrolled * 0.2}px`;
    }
  };

  window.addEventListener("scroll", handleScroll);

  // Cleanup: remove event listener when component unmounts
  return () => {
    window.removeEventListener("scroll", handleScroll);
  };
}, []);

// ── Service Section Voice Trigger ─────────────────────────────
useEffect(() => {
  if (!serviceRef.current) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !serviceSectionSpoken) {
          setServiceSectionSpoken(true);
          setAnikaExternalTrigger({
            section : 'service',
            texts   : new Array(14).fill(''),  // length=14, names come from activeServiceFeature ticks
            id      : Date.now(),
          });
        }
      });
    },
    { threshold: 0.3 }
  );

  observer.observe(serviceRef.current);
  return () => observer.disconnect();
}, [serviceSectionSpoken]);
// ── Admin / FeaturesUniverse Section Voice Trigger ─────────────
useEffect(() => {
  if (!integrationsRef.current) return;

  const adminText =
    "Explore our AI-powered features designed to revolutionize society management. " +
    "Click on any feature icon to discover how it can transform your community operations.";

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !adminSectionSpoken) {
          setAdminSectionSpoken(true);
          setAnikaExternalTrigger({
            section : 'admin',
            texts   : [adminText],
            id      : Date.now(),
          });
        }
      });
    },
    { threshold: 0.3 }
  );

  observer.observe(integrationsRef.current);
  return () => observer.disconnect();
}, [adminSectionSpoken]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };
 const scrolldown=()=>{
  window.scrollTo(800,800);
 }
  return (
      <>
      <canvas ref={canvasRef} className="particle-canvas" />

      <section className="socity-main-home">
        {/* ========================= Banner page ======================= */}
        <article className="society-main-home-gap" ref={homeRef}>
          <div className="society-main-home-faded">
         <header className="society-main-header">
  <div className="society-logo-sec">
    <img src={logs} alt="" />
    <h1>SocietyConnect.Ai</h1>
  </div>

  {/* Hamburger Menu Icon - Only visible on mobile */}
  <div className="society-hamburger-icon" onClick={toggleMobileMenu}>
    <span className={isMobileMenuOpen ? 'open' : ''}></span>
    <span className={isMobileMenuOpen ? 'open' : ''}></span>
    <span className={isMobileMenuOpen ? 'open' : ''}></span>
  </div>

  {/* Navigation Links - Desktop and Mobile Dropdown */}
  <div className={`society-navlink-sec ${isMobileMenuOpen ? 'mobile-active' : ''}`}>
    <ul>
      <li onClick={() => { scrollToSection(homeRef); setIsMobileMenuOpen(false); }} style={{ cursor: 'pointer' }}>Home</li>
      <li onClick={() => { scrollToSection(serviceRef); setIsMobileMenuOpen(false); }} style={{ cursor: 'pointer' }}>Service</li>
      <li onClick={() => { scrollToSection(aboutRef); setIsMobileMenuOpen(false); }} style={{ cursor: 'pointer' }}>About Us</li>
      <li onClick={() => { scrollToSection(contactRef); setIsMobileMenuOpen(false); }} style={{ cursor: 'pointer' }}>Contact Us</li>
      <li onClick={() => { navigate("/blogs"); setIsMobileMenuOpen(false); }}>Blog</li>
    </ul>
  </div>

  <div className="society-header-actions">
    {/* <div className="society-button-sec">
      <button className="society-mainlogin-btn" onClick={() => { scrollToSection(serviceRef); setIsMobileMenuOpen(false); }}>Get Started</button>
    </div> */}

{/* <AnikaAi
  voiceService={voiceService}
  autoStart={anikaAutoStart}
  introTexts={texts}
  onCallStateChange={(isActive) => {
    setAnikaCallActive(isActive);
  }}
  externalTrigger={anikaExternalTrigger}
  activeServiceFeature={
    anikaCallActive
      ? { name: integrations[serviceActiveIntegration]?.name, index: serviceActiveIntegration }
      : null
  }
/> */}
<AnikaAi
  voiceService={voiceService}
  autoStart={anikaAutoStart}
  introTexts={texts}
  onCallStateChange={(isActive) => {
    setAnikaCallActive(isActive);
  }}
  externalTrigger={anikaExternalTrigger}
  activeServiceFeature={
    anikaCallActive
      ? { name: integrations[serviceActiveIntegration]?.name, index: serviceActiveIntegration }
      : null
  }
  currentSection={currentViewSection}
  serviceFeatureTexts={integrations.map(i => i.name)}
  adminText={
    "Explore our AI-powered features designed to revolutionize society management. " +
    "Click on any feature icon to discover how it can transform your community operations."
  }
/>
    {/* Original Offcanvas Menu Icon - Keep for additional menu */}
  </div>
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      xmlns="http://www.w3.org/2000/svg"
      className="cursor-pointer society-offcanvas-icon"
      type="button"
      data-bs-toggle="offcanvas"
      data-bs-target="#offcanvasRight"
      aria-controls="offcanvasRight"
    >
      <rect
        x="10"
        y="16"
        width="30"
        height="2"
        rx="1"
        fill="#FFFFFF"
      />
      <rect
        x="10"
        y="24"
        width="18"
        height="2"
        rx="1"
        fill="#FFFFFF"
      />
      <rect
        x="10"
        y="32"
        width="18"
        height="2"
        rx="1"
        fill="#FFFFFF"
      />
    </svg>
</header>

          <main className="society-maintext-sec">
            <div className="society-leftside-texts">
              <h1 className="animated-heading">
                    Transform Society <br />Management With the <br />Power of 
                    <span
                      id="wave-char2"
                      style={{
                      marginLeft:"20px"
                      }}
                    >
                     AI-Automation
                    </span>
              </h1>
              <p>
                Revolutionize your residential society management with
                intelligent automation, <br />
                seamless communication, and data-driven insights for better
                community living.
              </p>
              <div className="d-flex gap-3">

              <button className="landingpage-home-buttons">Explore Our Features</button>
              <button className="landingpage-home-buttons" onClick={() => { scrollToSection(contactRef); setIsMobileMenuOpen(false); }}>Contact Us</button>
              </div>

            </div>
          </main>
          </div>
        </article>
        {/* =========================All Feature page ======================= */}


<Services
  serviceRef={serviceRef}
  activeIntegration={serviceActiveIntegration}
  onActiveChange={setServiceActiveIntegration}
/>
{/* ================================= Admin Services ============================================== */}
         <div className="signelar-container d-flex flex-column " >
          <div className="signelar-container-gapsss">
            <div 
            id="integrations-section"
            ref={integrationsRef}
            className={`featuresuniverse fadeUp ${isIntegrationsVisible ? 'visible' : ''}`}
          >
            <FeaturesUniverse />
          </div>
          </div>
        </div>

        {/* ============================== signaller ======================= */}
       <div className="sign-sc-wrapper" ref={sectionRef}>
      <section className="sign-main-section">
        <div className="d-flex flex-column sign-head">
          <button className="integrations-badge fs-6">Signaller</button>
          <h1 className="signelar-heading">Signaller Feature</h1>
          <p className="about-subtitle mt-0">
            The Signaller feature enables instant, reliable communication within the community by sending real-time alerts and notifications to residents, staff, and administrators. It ensures that important information reaches the right people at the right time without delays or confusion.
          </p>
        </div>
        
        <article className="sign-main-gapss">
          <div className="sign-left-secs">
            {rooms?.map((room, index) => (
              <div
                key={room.id}
                className={`sign-sc-nav-item ${activeRoom === index ? 'active' : ''}`}
                onClick={() => setActiveRoom(index)}
              >
                <div className="sign-sc-nav-number">{String(index + 1).padStart(2, '0')}</div>
                <div className="sign-sc-nav-content">
                  <h3>{room.title}</h3>
                  <p>{room.name}</p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="sign-right-feture">
            <div className="sign-sc-image-container">
              {rooms.map((room, index) => (
                <div
                  key={room.id}
                  className={`sign-sc-image-wrapper ${activeRoom === index ? 'active' : ''}`}
                >
                  <img src={room.image} alt={room.title} className="sign-sc-image" />
                  <div className="sign-sc-overlay"></div>
                  <div className="sign-sc-text-content">
                    <h2 className="sign-sc-title">{room.title}</h2>
                    <p className="sign-sc-description">{room.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </article>
      </section>
    </div>
        {/* ======================== aboutus section =================== */}
        <div className="about-dashboard-container" ref={aboutRef}>
          {/* Gradient Background */}
          <div className="about-gradient-bg"></div>

          <div className="about-content-wrapper">
            {/* Left Section */}
            <div className="about-left-section">
              <div>
                <button className="integrations-badge">About Us</button>{" "}
                <span
                  style={{
                    height: "1px",
                    width: "100px",
                    backgroundColor: "red",
                  }}
                >
                  {" "}
                </span>
              </div>

              <h1 className="about-main-title">
                {"Smart Living for Modern".split("").map((char, index) => (
                  <span
                    key={index}
                    className="wave-char"
                    style={{
                      animationDelay: `${(17 + index) * 0.03}s`,
                      color: "white",
                    }}
                  >
                    {char === " " ? "\u00A0" : char}
                  </span>
                ))}{" "}
                <br />
                {"Society Management".split("").map((char, index) => (
                  <span
                    key={index}
                    className="wave-char"
                    style={{
                      animationDelay: `${(17 + index) * 0.03}s`,
                      color: "white",
                    }}
                  >
                    {char === " " ? "\u00A0" : char}
                  </span>
                ))}
              </h1>
              <p className="about-subtitle">
                Transform your residential community with our comprehensive
                society management platform. Streamline operations, enhance
                security, and foster better communication among residents while
                maintaining complete transparency and accountability.
              </p>

              <div className="about-features">
                <div className="about-feature-card">
                  <div className="about-feature-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 2L2 7L12 12L22 7L12 2Z"
                        stroke="#6C5CE7"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M2 17L12 22L22 17"
                        stroke="#6C5CE7"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M2 12L12 17L22 12"
                        stroke="#6C5CE7"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="about-feature-content">
                    <h3>Community Growth</h3>
                    <p>
                      Building stronger neighborhoods with seamless management
                    </p>
                  </div>
                </div>

                <div className="about-feature-card">
                  <div className="about-feature-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="#6C5CE7"
                        strokeWidth="2"
                      />
                      <path
                        d="M12 6V12L16 14"
                        stroke="#6C5CE7"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                  <div className="about-feature-content">
                    <h3>Smart Solutions</h3>
                    <p>
                      Digital tools for efficient society operations and
                      security
                    </p>
                  </div>
                </div>
              </div>

              <button className="about-get-started-btn">
                Get Started
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M4 10H16M16 10L10 4M16 10L10 16"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>

            {/* Right Section - Dashboard Cards */}
            <div className="about-right-section">
              {/* Storage Card */}
              <div className="about-card about-storage-card">
                <div className="about-card-header">
                  <h3>Storage</h3>
                </div>

                <div className="about-storage-content">
                  <div className="about-legend">
                    <div className="about-legend-item">
                      <span className="about-dot about-red"></span>
                      <span>Free Space</span>
                    </div>
                    <div className="about-legend-item">
                      <span className="about-dot about-purple"></span>
                      <span>Used Spaces</span>
                    </div>
                  </div>

                  <div className="about-donut-chart">
                    <svg width="150" height="150" viewBox="0 0 150 150">
                      <circle
                        cx="75"
                        cy="75"
                        r="60"
                        fill="none"
                        stroke="#FF6B6B"
                        strokeWidth="20"
                        strokeDasharray="251.2 377"
                        transform="rotate(-90 75 75)"
                      />
                      <circle
                        cx="75"
                        cy="75"
                        r="60"
                        fill="none"
                        stroke="#6C5CE7"
                        strokeWidth="20"
                        strokeDasharray="126 377"
                        strokeDashoffset="-251.2"
                        transform="rotate(-90 75 75)"
                      />
                    </svg>
                    <div className="about-chart-center">67%</div>
                  </div>
                </div>

                <div className="about-data-processing">
                  <span>Data Processing</span>
                  <span>70%</span>
                </div>
              </div>

              {/* Data Analytics Card */}
              <div className="about-card about-analytics-card">
                <div className="about-card-header">
                  <h3>Data Analytics</h3>
                </div>

                <div className="about-growth-badge">+30%</div>

                <div className="about-bar-chart">
                  <div
                    className="about-bar"
                    style={{ height: "60%", backgroundColor: "#6C5CE7" }}
                  ></div>
                  <div
                    className="about-bar"
                    style={{ height: "80%", backgroundColor: "#FF8C42" }}
                  ></div>
                  <div
                    className="about-bar"
                    style={{ height: "65%", backgroundColor: "#2ECC71" }}
                  ></div>
                  <div
                    className="about-bar"
                    style={{ height: "70%", backgroundColor: "#3498DB" }}
                  ></div>
                  <div
                    className="about-bar"
                    style={{ height: "85%", backgroundColor: "#6C5CE7" }}
                  ></div>
                  <div
                    className="about-bar"
                    style={{ height: "75%", backgroundColor: "#A569BD" }}
                  ></div>
                </div>

                <div className="about-chart-labels">
                  <span>S</span>
                  <span>M</span>
                  <span>T</span>
                  <span>W</span>
                  <span>T</span>
                  <span>F</span>
                </div>
              </div>

              {/* Users Card */}
              <div className="about-card about-users-card">
                <div className="about-users-circle">
                  <div className="about-user-avatar about-top">
                    <img src="https://i.pravatar.cc/150?img=5" alt="User" />
                  </div>
                  <div className="about-user-avatar about-left">
                    <img src="https://i.pravatar.cc/150?img=9" alt="User" />
                  </div>
                  <div className="about-user-avatar about-right">
                    <img src="https://i.pravatar.cc/150?img=32" alt="User" />
                  </div>
                  <div className="about-connecting-dots">
                    <span className="about-dot-orange"></span>
                    <span className="about-dot-blue"></span>
                    <span className="about-dot-green"></span>
                  </div>
                </div>
                <div className="about-users-count">
                  <div className="about-count">1350+</div>
                  <div className="about-label">Users</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ============================ contact us====================================== */}
        <div className="contact-wrapper"  ref={contactRef}>
          <div className="contact-grid">
            {/* Left Side - Image and Testimonials */}
            <div className="left-column">
              <div className="image-container">
                <img
                  src={contact}
                  alt="Customer Support Representative"
                  className="main-image"
                />
              </div>

              <div className="testimonial-slider">
                <div className="testimonial-item" key={currentIndex}>
                  <p className="quote-text">
                    "{testimonials[currentIndex].quote}"
                  </p>
                  <h4 className="person-name">
                    {testimonials[currentIndex].name}
                  </h4>
                  <p className="person-role">
                    {testimonials[currentIndex].role}
                  </p>
                </div>

                <div className="dots-container">
                  {testimonials.map((_, index) => (
                    <span
                      key={index}
                      className={`dot-indicator ${
                        index === currentIndex ? "dot-active" : ""
                      }`}
                      onClick={() => goToSlide(index)}
                    />
                  ))}
                </div>
              </div>
            </div>

            {/* Right Side - Contact Form */}
            <div className="right-column">
              <div className="form-section">
                <span className="integrations-badge">Connect With Us</span>
                <h1 className="main-heading">
                  We're Here To <span className="blue-text">Help</span> You!
                </h1>
                <p className="sub-heading">
                  Our dedicated support team is ready to assist you with
                  anything you need regarding our Society Management System.
                </p>

                <div className="form-container">
                  <div className="input-row">
                    <div className="input-wrapper">
                      <label className="input-label">Full Name</label>
                      <input
                        type="text"
                        name="fullName"
                        className="text-input"
                        placeholder="e.g. John Doe"
                        value={formData.fullName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors.fullName && touched.fullName && (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            marginTop: "4px",
                            display: "block",
                            letterSpacing:"1px"
                          }}
                        >
                          {errors.fullName}
                        </span>
                      )}
                    </div>
                    <div className="input-wrapper">
                      <label className="input-label">Phone</label>
                      <input
                        type="tel"
                        name="phone"
                        className="text-input"
                        placeholder="e.g. +123 234 567"
                        value={formData.phone}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors.phone && touched.phone && (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            marginTop: "4px",
                            display: "block",
                            letterSpacing:"1px"
                          }}
                        >
                          {errors.phone}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="input-row">
                    <div className="input-wrapper">
                      <label className="input-label">Email</label>
                      <input
                        type="email"
                        name="email"
                        className="text-input"
                        placeholder="e.g. info@yoursite.com"
                        value={formData.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors.email && touched.email && (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            marginTop: "4px",
                            display: "block",
                            letterSpacing:"1px"
                          }}
                        >
                          {errors.email}
                        </span>
                      )}
                    </div>
                    <div className="input-wrapper">
                      <label className="input-label">Subject</label>
                      <input
                        type="text"
                        name="subject"
                        className="text-input"
                        placeholder="e.g. Question - Nadine Chan"
                        value={formData.subject}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors.subject && touched.subject && (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            marginTop: "4px",
                            display: "block",
                            letterSpacing:"1px"
                          }}
                        >
                          {errors.subject}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="input-wrapper full-width">
                    <label className="input-label">Message</label>
                    <div className="textarea-wrapper">
                      <textarea
                        name="message"
                        className="text-area"
                        placeholder="Write your message or question here ..."
                        value={formData.message}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        rows="3"
                      />
                    </div>
                  </div>

                  <button className="submit-btn" onClick={handleSubmitform}>
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* =================== subscrive society ================ */}
        <section className="news-subcribe-society">
          <div className="newsletter-container">
            <div className="decorative-shape left-shape"></div>
            <div className="decorative-shape right-shape"></div>

            <div className="newsletter-content">
              <h1 className="newsletter-title">Subscribe to Society Blogs</h1>
              <p className="newsletter-subtitle">
                Stay connected with your community - Get updates on events,
                announcements, and society Blogs
              </p>

              <div className="newsletter-form">
                <input
                  type="email"
                  className="email-input"
                  placeholder="Enter your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button onClick={handleSubmit} className="subscribe-button">
                  Subscribe
                </button>
              </div>

              {isSubmitted && (
                <div className="success-message">
                  Thank you for subscribing! You'll receive society updates
                  soon.
                </div>
              )}
            </div>
          </div>
        </section>
        {/* ==================================== footer ======================================== */}
        <footer className="society-Footer-last">
          <div className="footer-society-container">
            {/* Left Section */}
            <div className="footer-society-left">
              <div className="society-logo-sec" style={{ marginLeft: "-15px" }}>
                <img
                  src={logs}
                  alt=""
                  style={{ height: "60px", width: "60px" }}
                />
                <h1>SocietyConnect.ai</h1>
              </div>
              <h2 className="footer-society-title">
                Stay Update with our
                <br />
                Latest Offerings
              </h2>
              <button className="footer-society-btn">
                Request Demo
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M4 10H16M16 10L11 5M16 10L11 15"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>

            {/* Products Section */}
            <div className="footer-society-column">
              <h3 className="footer-society-heading">Products</h3>
             <ul className="footer-society-links">
              <li>
                <a href="#" onClick={(e) => { e.preventDefault(); scrollToSection(homeRef); }}>Home</a>
              </li>
              <li>
                <a href="#" onClick={(e) => { e.preventDefault(); scrollToSection(serviceRef); }}>Service</a>
              </li>
              <li>
                <a href="#" onClick={(e) => { e.preventDefault(); scrollToSection(aboutRef); }}>About Us</a>
              </li>
              <li>
                <a href="#" onClick={(e) => { e.preventDefault(); scrollToSection(contactRef); }}>Contact Us</a>
              </li>
            </ul>
            </div>

            {/* Utility Section */}
            <div className="footer-society-column">
              <h3 className="footer-society-heading">Utility</h3>
              <ul className="footer-society-links">
                <li>
                  <a href="#passwords">Passwords</a>
                </li>
                <li>
                  <a href="#licensing">Licensing</a>
                </li>
                <li>
                  <a href="#pricing-plan">Pricing Plan</a>
                </li>
                <li>
                  <a href="#instructions">Instructions</a>
                </li>
                <li>
                  <a href="#error">Error - 404</a>
                </li>
              </ul>
            </div>

            {/* Newsletter Section */}
            <div className="footer-society-newsletter">
              <h3 className="footer-society-heading text-center">Blogs</h3>
              <p className="footer-society-newsletter-text">
                Sign Up our Blogs get
                <br />
                Latest Updates
              </p>
              <div className="footer-society-form">
                <input
                  type="email"
                  placeholder="Email"
                  value={emailfooter}
                  onChange={(e) => setEmailFooter(e.target.value)}
                  className="footer-society-input"
                />
                <button
                  onClick={handleSubmitFooter}
                  className="footer-society-submit-btn"
                >
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                      d="M18 2L9 11M18 2L12 18L9 11M18 2L2 8L9 11"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          {/* Copyright */}
          <div className="footer-society-copyright">
            <p>
              {" "}
              © Copyright 2026 | Reserved by{" "}
              <b style={{ color: "#52BFE5" }}> Ohhpro Technologies Pvt.Ltd</b>
            </p>
          </div>
        </footer>
      </section>
       {showAudioModal && (
      <AudioEnableModal onEnable={handleStartExperience} />
      )}

      {/* ====================== society -off========= */}
      <div className="society-offcanvas-container">
        <div
          className="offcanvas offcanvas-end"
          style={{ background: "#0b0336ff" }}
          tabIndex="-1"
          id="offcanvasRight"
          aria-labelledby="offcanvasRightLabel"
        >
          <div className="offcanvas-header d-flex justify-content-between mt-2">
            <div className="society-logo-sec">
              <img src={logs} alt="Logo" />
              <h1>SocietyConnect.ai</h1>
            </div>
            <svg
              width="40"
              height="40"
              viewBox="0 0 50 50"
              xmlns="http://www.w3.org/2000/svg"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              className="cursor-pointer close-btns-side"
            >
              <rect
                x="12"
                y="24"
                width="26"
                height="2"
                rx="1"
                transform="rotate(45 25 25)"
                fill="#FFFFFF"
              />
              <rect
                x="12"
                y="24"
                width="26"
                height="2"
                rx="1"
                transform="rotate(-45 25 25)"
                fill="#FFFFFF"
              />
            </svg>
          </div>

          <div className="offcanvas-body">
            {/* About Us Section */}
            <div className="society-about-section">
              <h3 className="society-section-title">About Us</h3>
              <p className="society-about-text">
                Transform your residential community with our comprehensive
                society management platform. We streamline operations, enhance
                security, and faster better communication among residents while
                maintaining complete transparency and accountability. Our
                digital solution empowers housing societies with smart tools for
                efficient community management, visitor tracking, maintenance
                requests, and seamless resident engagement.
              </p>
            </div>

            {/* Contact Info Section */}
            <div className="society-contact-section">
              <h3 className="society-section-title">Contact Info</h3>

              <div className="society-contact-item">
                <svg
                  className="society-contact-icon"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                    fill="#6C5CE7"
                  />
                </svg>
                <span>
                  Mig-56, Kanan Vihar Phase-2, Near Kananeswar Temple, Patia,
                  Bhubaneswar, Odisha-751017
                </span>
              </div>

              <div className="society-contact-item">
                <svg
                  className="society-contact-icon"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
                    fill="#6C5CE7"
                  />
                </svg>
                <span>+91 8093220166</span>
              </div>

              <div className="society-contact-item">
                <svg
                  className="society-contact-icon"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                    fill="#6C5CE7"
                  />
                </svg>
                <span>contactus@ohhpro.com</span>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="society-action-buttons">
              <button className="society-btn society-btn-signup">
                Sign Up
              </button>
              <button className="society-btn society-btn-signin">
                Sign In
              </button>
            </div>

            {/* Social Media Links */}
            <div className="society-social-links">
              <a href="#" className="society-social-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                    fill="white"
                  />
                  <circle cx="12" cy="12" r="3" fill="white" />
                </svg>
              </a>
              <a href="#" className="society-social-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z"
                    fill="white"
                  />
                </svg>
              </a>
              <a href="#" className="society-social-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"
                    fill="white"
                  />
                </svg>
              </a>
              <a href="#" className="society-social-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <rect
                    x="2"
                    y="2"
                    width="20"
                    height="20"
                    rx="5"
                    stroke="white"
                    strokeWidth="2"
                    fill="none"
                  />
                  <circle
                    cx="12"
                    cy="12"
                    r="4"
                    stroke="white"
                    strokeWidth="2"
                    fill="none"
                  />
                  <circle cx="17.5" cy="6.5" r="1.5" fill="white" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      </>
  );
};

export default LandingPage;
